
export default function PrivacySection() {
  return (
    <section id="sigilo" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Seu Sigilo Está <span className="text-red-500">100% Garantido</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Entendemos que esta é uma situação <strong>extremamente delicada</strong>. 
            Sua privacidade é nossa prioridade absoluta.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20security%20vault%20with%20documents%2C%20confidential%20files%2C%20secure%20lock%20system%2C%20modern%20office%20setting%20with%20privacy%20screens%2C%20professional%20lighting%20emphasizing%20security%20and%20confidentiality%2C%20high%20quality%20photography&width=600&height=400&seq=privacy-img&orientation=landscape"
              alt="Segurança e confidencialidade total"
              className="rounded-lg shadow-lg w-full object-cover object-top"
            />
          </div>
          
          <div className="space-y-6">
            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold">Proteção Legal</h3>
              </div>
              <p className="text-gray-300">
                Seguimos rigorosamente a <strong>Lei 13.432/2017</strong> e <strong>LGPD</strong>. 
                Seus dados estão protegidos por sigilo profissional.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-eye-off-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold">Investigação Invisível</h3>
              </div>
              <p className="text-gray-300">
                Trabalho realizado com <strong>total sigilo</strong>. 
                Usamos técnicas discretas e profissionais.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-lock-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold">Dados Criptografados</h3>
              </div>
              <p className="text-gray-300">
                Todas as informações são <strong>criptografadas</strong> e armazenadas 
                em servidores seguros. Acesso restrito apenas aos investigadores.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-delete-bin-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold">Destruição Segura</h3>
              </div>
              <p className="text-gray-300">
                Após a entrega do relatório, todos os dados temporários são 
                <strong> destruídos com segurança</strong>.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-red-900/30 border border-red-500 rounded-lg p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-red-400 mb-4">
              🔒 Promessa de Sigilo Absoluto
            </h3>
            <p className="text-gray-300 text-lg mb-6">
              <strong>Garantimos por escrito:</strong> Trabalho realizado com total sigilo e discrição. 
              Se houver qualquer falha por nossa parte, devolvemos 100% do valor pago.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <i className="ri-shield-check-line text-3xl text-red-500 mb-2"></i>
                <div className="text-white font-semibold">Sigilo Profissional</div>
              </div>
              <div className="text-center">
                <i className="ri-lock-line text-3xl text-red-500 mb-2"></i>
                <div className="text-white font-semibold">Dados Protegidos</div>
              </div>
              <div className="text-center">
                <i className="ri-eye-off-line text-3xl text-red-500 mb-2"></i>
                <div className="text-white font-semibold">Investigação Invisível</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-gray-800 rounded-lg p-8 max-w-5xl mx-auto">
          <h3 className="text-2xl font-bold text-center mb-8 text-red-400">
            Conformidade Legal e Regulatória
          </h3>
          <p className="text-gray-300 text-center mb-8">
            Toda a atividade é realizada em estrita conformidade com as normas que regulamentam o trabalho investigativo no Brasil:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-900 p-6 rounded-lg">
              <div className="flex items-start">
                <i className="ri-file-list-3-line text-red-500 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-white mb-2">Lei 13.432/2017</h4>
                  <p className="text-gray-400 text-sm">
                    Regulamenta a profissão de detetive particular
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg">
              <div className="flex items-start">
                <i className="ri-scales-3-line text-red-500 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-white mb-2">Provimento 188/2018 da OAB</h4>
                  <p className="text-gray-400 text-sm">
                    Investigação defensiva
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg">
              <div className="flex items-start">
                <i className="ri-shield-user-line text-red-500 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-white mb-2">LGPD - Lei 13.709/2018</h4>
                  <p className="text-gray-400 text-sm">
                    Segurança e sigilo no tratamento de dados
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 p-6 rounded-lg">
              <div className="flex items-start">
                <i className="ri-government-line text-red-500 text-2xl mr-4 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-white mb-2">Constituição Federal Art. 5º</h4>
                  <p className="text-gray-400 text-sm">
                    Privacidade e intimidade
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
